import React from "react";
import styled from "styled-components";
import baseStyle from "../../style";

const Select = styled.select`
  ${baseStyle};
  background-color: white;
`;

export default (props) => {
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    if (props.options) {
      setOptions(props.options);
    }
  }, [props.options]);

  return (
    <Select {...props}>
      {options.map((field, idx) => {
        return (
          <option selected={field.selected} value={field.value} key={`select-option-${idx}=${field.value}`}>
            {field.label}
          </option>
        );
      })}
    </Select>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Input/components/Select/index.jsx